import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import SeoInputDialog from './SeoInputDialog';
import { toast } from 'react-hot-toast';

const SeoComp = ({ offering_id }) => {
    const [openDialog, setOpenDialog] = useState(false);
    const [seoDetails, setSeoDetails] = useState();
    const [seoImages, setSeoImages] = useState([]);
    const [seoData, setSeoData] = useState({
        rating_count: '',
        rating_value: '',
        review_count: '',
        brand_name: ''
    })


    function getOfferSEO() {
        fetch(`${process.env.REACT_APP_BASE_URL_VMS}/api/v1/seo/${offering_id}`, {
            
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then((response) => response.json())
            .then((data) => {
                if (data?.length) {
                    setSeoDetails({
                        title: data[0]?.title,
                        keywords: data[0]?.keywords,
                        description: data[0]?.description,
                        share_image: data[0]?.image,
                    })
                    setSeoData({
                        rating_count: data[0]?.rating_count || '',
                        rating_value: data[0]?.rating_value || '',
                        review_count: data[0]?.review_count || '',
                        brand_name: data[0]?.brand_name || ''
                    });
                }
                // Handle response as needed
            })
            .catch((error) => {
                console.error('Error:', error);
                // Handle error
            });
    }

    function getOfferSEOImage() {
        fetch(`${process.env.REACT_APP_BASE_URL_VMS}/api/v1/seo/seo_shareImages`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then((response) => response.json())
            .then((data) => {
                setSeoImages(data)
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }
    useEffect(() => {
        getOfferSEOImage()
    }, [])

    const handleSave = async (formData) => {

        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL_VMS}/api/v1/seo/${offering_id}`, {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                throw new Error(`Server responded with status ${response.status}`);
            }

            const data = await response.json();

            if (Array.isArray(data) && data.length > 0) {
                const item = data[0];
                setSeoDetails({
                    title: item.title || '',
                    keywords: item.keywords || '',
                    description: item.description || '',
                    share_image: item.image || '',
                    rating_count: item.rating_count || 0,
                    rating_value: item.rating_value || 0,
                    review_count: item.review_count || 0,
                    brand_name: item.brand_name || '',
                });
                toast.success('SEO details saved successfully');
            } else {
                toast.error('No SEO details returned from the server');
            }
        } catch (error) {
            console.error('Error: failed to save SEO details.', error);
            toast.error('Something went wrong while saving SEO details');
        }
    };


    function handleUpdate(formData) {
        fetch(`${process.env.REACT_APP_BASE_URL_VMS}/api/v1/seo/${offering_id}`, {
            method: 'PATCH',
            body: formData,
        })
            .then((response) => response.json())
            .then((data) => {
                setSeoDetails({
                    title: data[0]?.title,
                    keywords: data[0]?.keywords,
                    description: data[0]?.description,
                    share_image: data[0].image,
                    rating_count: data[0]?.rating_count,
                    rating_value: data[0]?.rating_value,
                    review_count: data[0]?.review_count,
                    brand_name: data[0]?.brand_name,
                })
                toast.success('SEO details updated successfully')
            })
            .catch((error) => {
                console.error('Error:', error);
                toast.error('Something went wrong while updating SEO details')
            });
    }

    function handleDelete() {
        fetch(`${process.env.REACT_APP_BASE_URL_VMS}/api/v1/seo/${offering_id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then((response) => response.json())
            .then((data) => {
                setSeoDetails(null)
                // Handle response as needed
                toast.success('SEO details deleted successfully')
            })
            .catch((error) => {
                console.error('Error:', error);
                // Handle error
                toast.error('Something went wrong while deleting SEO details')
            });
    }

    useEffect(() => {
        if (offering_id) {
            getOfferSEO();
        }
    }, [offering_id]);


    return (
        <div style={{ marginLeft: "40px", }}>
            <Button variant="contained" onClick={() => setOpenDialog(true)}>
                Offer SEO
            </Button>
            <SeoInputDialog
                open={openDialog}
                onClose={() => {
                    setOpenDialog(false);
                }}
                onSave={handleSave}
                onUpdate={handleUpdate}
                onDelete={handleDelete}
                seoDetails={seoDetails}
                offering_id={offering_id}
                seoImages={seoImages}
                setSeoData={setSeoData}
                seoData={seoData}
            />
        </div>
    );
};

export default SeoComp;
